import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Member from '@/components/Member'
import Members from '@/components/Members'  //会员中心
import Login from '@/components/Login'  //登录
import Forget from '@/components/Forget'  //忘记密码
import Register from '@/components/Register'  //注册
import DetailedLog from '@/components/DetailedLog'  //资金明细
import Information from '@/components/Information'
import NickName from '@/components/NickName'
import RealName from '@/components/RealName'
import BindBank from '@/components/BindBank'
import BinkPhone from "@/components/BinkPhone";
import BindEmail from "@/components/BindEmail";
import LoginPass from "@/components/LoginPass";
import WithdrawalPass from "@/components/WithdrawalPass";
import Agency from "@/components/Agency";
import ManageCost from "@/components/ManageCost";
import DeferredCost from "@/components/DeferredCost";
import DividedCost from "@/components/DividedCost";
import MyTeam from "@/components/MyTeam";
import AgencyLink from "@/components/AgencyLink";
import AgencyWithdrawal from "@/components/AgencyWithdrawal";
import AgencyTransfer from "@/components/AgencyTransfer";
import Service from "@/components/Service";
import ServiceChat from "@/components/ServiceChat";
import Recharge from "@/components/Recharge";
import RechargeInfo from "@/components/RechargeInfo";
import Withdrawal from "@/components/Withdrawal";
import AboutUs from "@/components/AboutUs";
import Activity from "@/components/Activity";
import ActivityDetail from "@/components/ActivityDetail";
import PopupContent from "@/components/PopupContent";
import FinanceFund from "@/components/FinanceFund";
import HolidayFund from "@/components/HolidayFund";
import FoundWinnersOld from "@/components/FoundWinnersOld";
import RiskControl from "@/components/RiskControl";
import FriendCoupon from "@/components/FriendCoupon";
import UserCoupon from "@/components/UserCoupon";
import Protocol from "@/components/Protocol";
import Couponinfo from "@/components/Couponinfo";
import Trading from "@/components/Trading";
import Quotes from "@/components/Quotes";
import QuotesDetails from "@/components/QuotesDetails";
import CapitalAccount from "@/components/CapitalAccount";
import AccountDetails from "@/components/AccountDetails";
import Kline from "@/components/Kline";
import ClosedCapitalInfo from "@/components/ClosedCapitalInfo";
import CreateCapitalAccounts from "@/components/CreateCapitalAccounts";
import FundDetails from "@/components/FundDetails";
import NewsInfo from "@/components/NewsInfo";
import NewsInfoDetailed from "@/components/NewsInfoDetailed";
import PositionInquiry from "@/components/PositionInquiry";
import WithdrawalInquiry from "@/components/WithdrawalInquiry";
import EntrustInquiry from "@/components/EntrustInquiry";
import DealInquiry from "@/components/DealInquiry";
import Announcement from "@/components/Announcement";
import AnnouncementDetailed from "@/components/AnnouncementDetailed";
import NoticeDetailed from "@/components/NoticeDetailed";
import TradingSearchStock from "@/components/TradingSearchStock";
import IncreaseCapitalInfo from "@/components/IncreaseCapitalInfo";
import IncreaseBondInfo from "@/components/IncreaseBondInfo";
import CapitalFundDetails from "@/components/CapitalFundDetails";
import Activities from "@/components/Activities";
import TimeBao from "@/components/TimeBao";
import TimeBaoDetails from "@/components/TimeBaoDetails";
import VoucherCost from "@/components/VoucherCost";
import AgentWithdrawalDetails from "@/components/AgentWithdrawalDetails";
import AgencyTransferWithdrawal from "@/components/AgencyTransferWithdrawal";
import ChatRoom from "@/components/ChatRoom";
import ChatRoomUser from "@/components/ChatRoomUser";
import ChannelRoom from "@/components/ChannelRoom";
import ChannelRoomUser from "@/components/ChannelRoomUser";
import ChannelDetails from "@/components/ChannelDetails";
import ChannelMembers from "@/components/ChannelMembers";
import ChannelMemberDetails from "@/components/ChannelMemberDetails";
import AgentCommissionDetails from "@/components/AgentCommissionDetails";
import ChannelMemberSearch from "@/components/ChannelMemberSearch";
import ChannelSearch from "@/components/ChannelSearch";
import AgentDepot from "@/components/AgentDepot";
import LowerLeverDepot from "@/components/LowerLeverDepot";
import CommonLoading from "@/components/CommonLoading";
import Gxpay from "@/components/Gxpay";
import VipReward from "@/components/VipReward";
import VipRewardDetails from "@/components/VipRewardDetails";
import LifetimeReward from "@/components/LifetimeReward";
import LifetimeRewardDetails from "@/components/LifetimeRewardDetails";
import Account from "@/components/Account";
import Voucher from "@/components/Voucher";
import StableCoinbao from "@/components/StableCoinbao";
import StableCoinbaoUserProductList from "@/components/StableCoinbaoUserProductList";
import StableCoinbaoFlowlog from "@/components/StableCoinbaoFlowlog";
import StableAvailableCreditDetails from "@/components/StableAvailableCreditDetails";
import ApiLineSelector from "@/components/ApiLineSelector";
import StablebaoFundingDescription from "@/components/StablebaoFundingDescription";
import WithdrawAddress from '@/components/WithdrawAddress.vue';




Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: '/api_line_selector',
      name: 'ApiLineSelector',
      component: ApiLineSelector
    },
    {
      path: '*',
      redirect: "/home"
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol
    },
    {
      path: '/member',
      name: 'Member',
      component: Member,
      children: [
        {
          path: 'members',
          name: 'Members',
          component: Members
        },
        {
          path: 'recharge',
          name: 'Recharge',
          component: Recharge
        },
        {
          path: 'recharge/info',
          name: 'RechargeInfo',
          component: RechargeInfo
        },
        {
          path: 'withdrawal',
          name: 'Withdrawal',
          component: Withdrawal
        },
        {
          path: 'detailed_log/:tab?',
          name: 'DetailedLog',
          component: DetailedLog
        },
        {
          path: 'information',
          name: 'Information',
          component: Information
        },
        {
          path: 'information/nick_name',
          name: 'NickName',
          component: NickName
        },
        {
          path: 'information/real_name',
          name: 'RealName',
          component: RealName
        },
        {
          path: 'information/bind_bank',
          name: 'BindBank',
          component: BindBank
        },
        {
          path: 'information/bink_phone',
          name: 'BinkPhone',
          component: BinkPhone
        },
        {
          path: 'information/bind_email',
          name: 'BindEmail',
          component: BindEmail
        },
        {
          path: 'information/login_pass',
          name: 'LoginPass',
          component: LoginPass
        },
        {
          path: 'information/withdrawal_pass',
          name: 'WithdrawalPass',
          component: WithdrawalPass
        },
        {
          path: 'information/withdrawal_address',
          name: 'WithdrawAddress',
          component: WithdrawAddress
        },
        {
          path: 'agency',
          name: 'Agency',
          component: Agency
        },
        {
          path: 'agency/manage_cost',
          name: 'ManageCost',
          component: ManageCost
        },
        {
          path: 'agency/deferred_cost',
          name: 'DeferredCost',
          component: DeferredCost
        },
        {
          path: 'agency/divided_cost',
          name: 'DividedCost',
          component: DividedCost
        },
        {
          path: 'agency/voucher_cost',
          name: 'VoucherCost',
          component: VoucherCost
        },
        {
          path: 'agency/agent_withdraw_details',
          name: 'AgentWithdrawalDetails',
          component: AgentWithdrawalDetails
        },
        {
          path: 'agency/agent_transfer_withdrawal',
          name: 'AgencyTransferWithdrawal',
          component: AgencyTransferWithdrawal
        },
        {
          path: 'agency/my_team',
          name: 'MyTeam',
          component: MyTeam
        },
        {
          path: 'agency/agency_link',
          name: 'AgencyLink',
          component: AgencyLink
        },
        {
          path: 'agency/agent_commission_details',
          name: 'AgentCommissionDetails',
          component: AgentCommissionDetails
        },
        {
          path: 'agency/agent_depot/:tab?',
          name: 'AgentDepot',
          component: AgentDepot
        },
        {
          path: 'agency/lower_lever_depot',
          name: 'LowerLeverDepot',
          component: LowerLeverDepot
        },
        // {
        //   path: 'agency/agency_withdrawal',
        //   name: 'AgencyWithdrawal',
        //   component: AgencyWithdrawal
        // },
        // {
        //   path: 'agency/agency_transfer',
        //   name: 'AgencyTransfer',
        //   component: AgencyTransfer
        // },
        {
          path: 'finance_fund',
          name: 'FinanceFund',
          component: FinanceFund
        },
        {
          path: 'holiday_fund',
          name: 'HolidayFund',
          component: HolidayFund
        },
        {
          path: 'risk_control',
          name: 'RiskControl',
          component: RiskControl
        },
        {
          path: 'friend_coupon',
          name: 'FriendCoupon',
          component: FriendCoupon
        },
        {
          path: 'user_coupon',
          name: 'UserCoupon',
          component: UserCoupon
        },
        {
          path: 'position_inquiry',
          name: 'PositionInquiry',
          component: PositionInquiry
        },
        {
          path: 'withdrawal_inquiry',
          name: 'WithdrawalInquiry',
          component: WithdrawalInquiry
        },
        {
          path: 'entrust_inquiry',
          name: 'EntrustInquiry',
          component: EntrustInquiry
        },
        {
          path: 'deal_inquiry',
          name: 'DealInquiry',
          component: DealInquiry
        },
        {
          path: 'announcement',
          name: 'Announcement',
          component: Announcement
        },
        {
          path: 'announcement_detailed',
          name: 'AnnouncementDetailed',
          component: AnnouncementDetailed
        },
        {
          path: 'time_bao',
          name: 'TimeBao',
          component: TimeBao
        },
        {
          path: 'time_bao_details',
          name: 'TimeBaoDetails',
          component: TimeBaoDetails
        },
        {
          path: 'account',
          name: 'Account',
          component: Account
        },
        {
          path: 'voucher',
          name: 'Voucher',
          component: Voucher
        },
        {
          path: 'gxpay',
          name: 'Gxpay',
          component: Gxpay
        },
        {
          path: 'vip_reward',
          name: 'VipReward',
          component: VipReward
        },
        {
          path: 'vip_reward_details',
          name: 'VipRewardDetails',
          component: VipRewardDetails
        },
        {
          path: 'lifetime_reward',
          name: 'LifetimeReward',
          component: LifetimeReward
        },
        {
          path: 'lifetime_reward_details',
          name: 'LifetimeRewardDetails',
          component: LifetimeRewardDetails
        },
             {
          path: 'stable_coinbao',
          name: 'StableCoinbao',
          component: StableCoinbao
        },
               {
          path: 'stable_coinbao_user_product_list',
          name: 'StableCoinbaoUserProductList',
          component: StableCoinbaoUserProductList
        },
          {
          path: 'Stable_coinbao_flowlog',
          name: 'StableCoinbaoFlowlog',
          component: StableCoinbaoFlowlog
        },
         {
          path: 'Stable_available_credit_details',
          name: 'StableAvailableCreditDetails',
          component: StableAvailableCreditDetails
        },
         {
          path: 'stable_description',
          name: 'StablebaoFundingDescription',
          component: StablebaoFundingDescription
        },
        
      ],
      redirect: "/member/members"
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forget',
      name: 'Forget',
      component: Forget
    },
    {
      path: '/zhuce9999',
      name: 'Register',
      component: Register
    },
    {
      path: '/registered',
      redirect: "/zhuce9999"
    },
    {
      path: '/login/registered',
      redirect: "/zhuce9999"
    },
    {
      path: '/login/register',
      redirect: "/zhuce9999"
    },
    {
      path: '/about_us',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/service_chat',
      name: 'ServiceChat',
      component: ServiceChat
    },
    {
      path: '/activity/activity_detail',
      name: 'ActivityDetail',
      component: ActivityDetail
    },
    {
      path: '/couponinfo',
      name: 'Couponinfo',
      component: Couponinfo
    },
    {
      path: '/activity/popup_content',
      name: 'PopupContent',
      component: PopupContent
    },
    {
      path: '/quotes',
      name: 'Quotes',
      component: Quotes
    },
    {
      path: '/quotes/quotes_details',
      name: 'QuotesDetails',
      component: QuotesDetails
    },
    {
      path: '/trading/:code?/:mode?',
      name: 'Trading',
      component: Trading
    },
    {
      path: '/trading_search_stock/:route?',
      name: 'TradingSearchStock',
      component: TradingSearchStock
    },
    {
      path: '/capital_account',
      name: 'CapitalAccount',
      component: CapitalAccount
    },
    {
      path: '/create_capital_accounts',
      name: 'CreateCapitalAccounts',
      component: CreateCapitalAccounts
    },
    {
      path: '/found_winners',
      name: 'FoundWinnersOld',
      component: FoundWinnersOld
    },
    {
      path: '/account_details',
      name: 'AccountDetails',
      component: AccountDetails
    },
    {
      path: '/kline/:code?',
      name: 'Kline',
      component: Kline,
    },
    {
      path: '/closed_capital_info',
      name: 'ClosedCapitalInfo',
      component: ClosedCapitalInfo
    },
    {
      path: '/fund_details',
      name: 'FundDetails',
      component: FundDetails
    },
    {
      path: '/news_info',
      name: 'NewsInfo',
      component: NewsInfo
    },
    {
      path: '/news_info_detailed',
      name: 'NewsInfoDetailed',
      component: NewsInfoDetailed
    },
    {
      path: '/notice_detailed',
      name: 'NoticeDetailed',
      component: NoticeDetailed
    },
    {
      path: '/increase_capital_info',
      name: 'IncreaseCapitalInfo',
      component: IncreaseCapitalInfo
    },
    {
      path: '/increase_bond_info',
      name: 'IncreaseBondInfo',
      component: IncreaseBondInfo
    },
    {
      path: '/capital_fund_details',
      name: 'CapitalFundDetails',
      component: CapitalFundDetails
    },
    {
      path: '/activities',
      name: 'Activities',
      component: Activities
    },
    {
      path: '/chatroom',
      name: 'ChatRoom',
      component: ChatRoom
    },
    {
      path: '/chatroom/chatroom_user/:account?',
      name: 'ChatRoomUser',
      component: ChatRoomUser
    },
    {
      path: '/channelroom',
      name: 'ChannelRoom',
      component: ChannelRoom
    },
    {
      path: '/channelroom/channelroom_user/:account?',
      name: 'ChannelRoomUser',
      component: ChannelRoomUser
    },
    {
      path: '/channeldetails',
      name: 'ChannelDetails',
      component: ChannelDetails
    },
    {
      path: '/channelmembers',
      name: 'ChannelMembers',
      component: ChannelMembers 
    },
    {
      path: '/channelmemberdetails',
      name: 'ChannelMemberDetails',
      component: ChannelMemberDetails 
    },
    {
      path: '/channel_member_search',
      name: 'ChannelMemberSearch',
      component: ChannelMemberSearch
    },
    {
      path: '/channel__search',
      name: 'ChannelSearch',
      component: ChannelSearch
    },
    {
      path: '/commonloading',
      name: 'CommonLoading',
      component: CommonLoading
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js